import { useState, useEffect } from 'react';

/**
 * Animated ellipsis label: strips trailing "..." from the text and cycles
 * through 1→2→3 dots as literal characters so they participate in the
 * parent's background-clip:text shimmer.
 */
export function AnimatedThinkingLabel({ text }: { text: string }) {
  const [dotCount, setDotCount] = useState(1);
  const base = text.replace(/\.{1,3}$/, '');

  useEffect(() => {
    const id = setInterval(() => {
      setDotCount(d => (d % 3) + 1);
    }, 350);
    return () => clearInterval(id);
  }, []);

  return (
    <span className="thinking-step-label thinking-step-label--active" aria-label={text}>
      {base}<span aria-hidden="true">{'.'.repeat(dotCount)}</span>
    </span>
  );
}
